import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]
  static values = { open: Boolean }

  toggle(event) {
    if (event) event.preventDefault()
    this.openValue = !this.openValue
  }

  openValueChanged() {
    if (this.hasContentTarget) {
      this.contentTarget.classList.toggle("hidden", !this.openValue)
    }
  }

  copy(event) {
    if (event) event.preventDefault()
    
    const markdown = this.buildMarkdown()
    
    navigator.clipboard.writeText(markdown).then(() => {
      const button = event.currentTarget
      const originalText = button.textContent
      button.textContent = "Copied!"
      button.classList.remove("bg-gray-600", "hover:bg-gray-700")
      button.classList.add("bg-green-600")
      
      setTimeout(() => {
        button.textContent = originalText
        button.classList.remove("bg-green-600")
        button.classList.add("bg-gray-600", "hover:bg-gray-700")
      }, 1500)
    })
  }

  buildMarkdown() {
    const sections = []
    const content = this.contentTarget
    
    // Parse each section from the panel
    const sectionDivs = content.querySelectorAll(':scope > div.border-b')
    
    sectionDivs.forEach(section => {
      const header = section.querySelector('.bg-gray-800')?.textContent?.trim()
      if (!header || header === 'Actions') return
      
      const rows = section.querySelectorAll('.px-3.py-2 > div')
      if (rows.length === 0) {
        // Check for nil/empty state text
        const emptyText = section.querySelector('.px-3.py-2')?.textContent?.trim()
        if (emptyText && header) {
          sections.push(`## ${header}\n${emptyText}`)
        }
        return
      }
      
      const lines = []
      rows.forEach(row => {
        const label = row.querySelector('.text-gray-400')?.textContent?.trim()
        const valueEl = row.querySelector('span:last-child') || row.lastElementChild
        let value = valueEl?.textContent?.trim() || 'nil'
        
        if (label) {
          lines.push(`- **${label}** ${value}`)
        }
      })
      
      if (lines.length > 0 && header) {
        sections.push(`## ${header}\n${lines.join('\n')}`)
      }
    })
    
    // Add warnings if present
    const warnings = content.querySelector('.bg-red-900\\/50')
    if (warnings) {
      const warningLines = []
      warnings.querySelectorAll('.text-red-300').forEach(w => {
        warningLines.push(`- ${w.textContent.trim()}`)
      })
      if (warningLines.length > 0) {
        sections.unshift(`## Warnings\n${warningLines.join('\n')}`)
      }
    }
    
    // Add footer info
    const footer = content.querySelector('.bg-gray-800:last-child .text-gray-500')
    if (footer) {
      sections.push(`---\n${footer.textContent.trim()}`)
    }
    
    return `# Debug Info\n\n${sections.join('\n\n')}`
  }
}
